// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var mediaWrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
      BsCssJs$PrezzeeRibbon.flexShrink(0),
      BsCssJs$PrezzeeRibbon.flexGrow(0),
      BsCssJs$PrezzeeRibbon.flexBasis(BsCssJs$PrezzeeRibbon.pct(50)),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.justifyContent("flexEnd"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tablet, [BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(20))]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [
            BsCssJs$PrezzeeRibbon.flexGrow(1),
            BsCssJs$PrezzeeRibbon.flexShrink(1),
            BsCssJs$PrezzeeRibbon.order(2),
            BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(10)),
            BsCssJs$PrezzeeRibbon.flexBasis("auto"),
            BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.px(482))
          ])
    ]);

var Styles = {
  mediaWrapper: mediaWrapper
};

function VideoTextPromoBlock__MediaWrapper(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    mediaWrapper,
                    className$1
                  ])
            });
}

var Settings;

var Video;

var SideImage;

var make = VideoTextPromoBlock__MediaWrapper;

export {
  Settings ,
  Video ,
  SideImage ,
  Styles ,
  make ,
}
/* mediaWrapper Not a pure module */
